import type { Client } from '@coachapp/shared';

export function isArchivedClient(client: Pick<Client, 'status'>): boolean {
  return client.status === 'ARCHIVED';
}

export function getClientStatusBadgeClass(status: Client['status'] | string): string {
  if (status === 'ACTIVE') return 'badge-success';
  if (status === 'ARCHIVED') {
    return 'badge bg-slate-100 text-slate-600';
  }
  return 'badge-danger';
}
